import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import Swiper from 'components/common/Swiper'
import ContainerComponent from 'components/shared/ContainerComponent/ContainerComponent'
import useMediaQuery from '@mui/material/useMediaQuery'
import sx from './styles'

const listBranches = [
  {
    id: 2,
    name: 'Querétaro:',
    branches: ['ClikAuto La Capilla.'],
  },
  // {
  //   id: 1,
  //   name: 'Ciudad de México:',
  //   branches: [
  //     'Toyota Universidad.',
  //     'Toyota Revolución.',
  //     'Honda Universidad.',
  //     'Honda Pedregal.',
  //     'Hyundai Universidad.',
  //     'Nissan Patriotismo.',
  //     'Nissan Revolución.',

  //   ],
  // },
  // {
  //   id: 1,
  //   name: 'León',
  //   branches: [
  //     'Kia Bajío.',
  //     'Kia Poliforum.',
  //   ],
  // },
]

const VtaBranchesGallery = ({
  sx: sxProp,
  images = [],
  title,
}) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  return (
    <Box
      sx={{ ...sx.root, ...sxProp }}
    >
      <ContainerComponent sx={sx.container}>
        <Grid
          container
          flexDirection={isMobile ? 'column' : 'row'}
          alignItems={isMobile ? '' : 'center'}
        >
          {isMobile && (
            <Typography
              sx={sx.title}
              variant="h3"
            >
              <FormattedMessage id={title} />
            </Typography>
          )}

          {isMobile && (
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
              sx={sx.imageSwiper}
            >
              <Swiper
                items={images}
                prefixIds="banners"
              />
            </Grid>
          )}

          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            {!isMobile && (
              <Typography
                sx={sx.title}
                variant="h3"
              >
                <FormattedMessage id={title} />
              </Typography>
            )}

            <Grid
              size={12}
              sx={sx.itemsContainer}
            >
              {listBranches
                && listBranches?.map((item) => (
                  <Grid
                    size={12}
                    key={item?.id}
                    mb={4}
                  >

                    <Typography
                      variant="subtitle1"
                      mb={1}
                    >
                      {item?.name}
                    </Typography>
                    {item?.branches.map((branch, index) => (
                      <Typography
                        key={index}
                        variant="body1"
                        mb={0.5}
                      >
                        {branch}
                      </Typography>
                    ))}

                  </Grid>
                ))}
            </Grid>
          </Grid>

          {!isMobile && (
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
              sx={sx.imageSwiper}
            >
              <Swiper
                items={images}
                prefixIds="banners"
              />
            </Grid>
          )}

        </Grid>

      </ContainerComponent>
    </Box>
  )
}

export default memo(VtaBranchesGallery)
